import { render, staticRenderFns } from "./Acolhimentos.vue?vue&type=template&id=60ac49ff&scoped=true"
import script from "./Acolhimentos.vue?vue&type=script&lang=js"
export * from "./Acolhimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ac49ff",
  null
  
)

export default component.exports